import ServiceTemplate from './ServiceTemplate';

const LowTestosterone = () => {
  const data = {
    title: 'Low Testosterone (Low T)',
    tagline: 'Optimize Energy. Strength. Drive.',
    description: 'Low Testosterone affects energy, libido, mood, and overall quality of life. Proper testing and evidence-based treatment can help restore vitality and well-being.',
    causesTitle: 'Signs of Low Testosterone',
    causes: [
      'Fatigue and low energy',
      'Decreased libido',
      'Weight gain',
      'Brain fog and difficulty concentrating',
      'Mood changes or irritability',
      'Loss of muscle mass',
      'Sleep disturbances',
    ],
    symptoms: [
      'Persistent fatigue',
      'Low sex drive',
      'Erectile difficulties',
      'Increased body fat',
      'Reduced muscle strength',
      'Depression or mood swings',
    ],
    treatments: [
      'Testosterone Replacement Therapy (TRT)',
      'Lifestyle optimization',
      'Nutritional guidance',
      'Regular monitoring and adjustment',
    ],
    faqs: [
      { q: 'How do I know if I have low testosterone?', a: 'A simple blood test can measure your testosterone levels. Dr. Havkin will evaluate your symptoms alongside lab results to determine if treatment is appropriate.' },
      { q: 'Is testosterone therapy safe?', a: 'When properly monitored, testosterone therapy is safe and effective for men with confirmed low levels. Regular follow-up ensures optimal results and safety.' },
      { q: 'How quickly will I see results?', a: 'Many men notice improvements in energy and mood within a few weeks. Full benefits typically develop over 3-6 months of consistent treatment.' },
    ],
    cta: 'Get your levels tested today.',
    seoTitle: 'Low Testosterone (Low T) Treatment Melbourne FL',
    seoDescription: 'Low testosterone testing and treatment in Melbourne, FL. Dr. Havkin provides evidence-based TRT to restore energy, strength, and vitality. Call (321) 500-4545.',
    seoKeywords: 'low testosterone treatment Melbourne FL, Low T therapy, testosterone replacement therapy, TRT doctor, hormone optimization',
    seoCanonical: '/services/low-testosterone',
  };

  return <ServiceTemplate {...data} />;
};

export default LowTestosterone;
